import Vue from "vue";
import Element from "element-ui";
/* import { */
/*   Header, */
/*   Container, */
/*   Main, */
/*   Row, */
/*   Col, */
/*   Card, */
/*   Table, */
/*   TableColumn, */
/*   Tag, */
/*   Tooltip, */
/*   Button, */
/*   Dialog, */
/*   Form, */
/*   FormItem, */
/*   Select, */
/*   Option, */
/*   Input, */
/*   Pagination, */
/* } from "element-ui"; */
import "../element-variables.scss";

import lang from "element-ui/lib/locale/lang/ru-RU";
import locale from "element-ui/lib/locale";

locale.use(lang);

Vue.use(Element);
/* Vue.use(Header); */
/* Vue.use(Container); */
/* Vue.use(Main); */
/* Vue.use(Row); */
/* Vue.use(Col); */
/* Vue.use(Card); */
/* Vue.use(Table); */
/* Vue.use(TableColumn); */
/* Vue.use(Tag); */
/* Vue.use(Tooltip); */
/* Vue.use(Button); */
/* Vue.use(Dialog); */
/* Vue.use(Form); */
/* Vue.use(FormItem); */
/* Vue.use(Select); */
/* Vue.use(Option); */
/* Vue.use(Input); */
/* Vue.use(Pagination); */
